// src/pages/caixas/CaixaMovLan.js
import React, { useState, useEffect } from 'react';
import Input from '../../components/input/Input.js';
import { useAlert } from '../../contexts/geral/AlertContext.js';
import { useMessage } from '../../contexts/geral/MessageContext.js';
import { CaixaMov } from '../../models/caixas/CaixaMov.js';
import { formatDate, formatTime } from '../../utils/dateTimeUtils.js';
import { useCaixaMov } from '../../contexts/caixas/CaixaMovContext.js';
import Select from '../../components/input/Select.js';
import { getDescricaoTipoMov, TipoMovCaixa } from '../../models/caixas/TipoMovCaixa.js';
import ModalPortal from '../../components/modalForm/ModalPortal';
import { formatNumeric, normalizeDecimalInputBr, parseCurrency } from '../../utils/numberUtils.js';



const CaixaMovLan = ({ show, onHide, caixa, setCaixa, usuario}) => {
    const { abrirCaixa, lancManual } = useCaixaMov();
    const { showAlert } = useAlert();
    const {showMessage} = useMessage();
    const [caixaMov, setCaixaMov] = useState(new CaixaMov());
    const [tipoMovCaixaSel, setTipoMovCaixaSel] = useState(TipoMovCaixa.Abertura);
    const [processando, setProcessando] = useState(false);


    useEffect(() => {
        //Por enquanto vou chumbar os dados padrão
        if (show) {
            setCaixaMov({...new CaixaMov(), caixaId:1, usuarioId:1, caixa: caixa, usuario:usuario, dataHoraMov: new Date(),
                vRec:'', vPag:'', observacao:''
            });
        }

    }, [show]);

    useEffect(() => {
        //Por enquanto vou chumbar os dados padrão
        setTipoMovCaixaSel(!caixa.aberto ? 1 : 2);

    }, [caixa]);


    const handleValorMovChange = (value) => {
        const valor = normalizeDecimalInputBr(value, 2).replace(/-/g, '');
        setCaixaMov({ ...caixaMov, vRec: valor, vPag: valor });
    };

    const handleValorMovBlur = (value) => {
        const valor = formatNumeric(parseCurrency(value), 2);
        setCaixaMov({ ...caixaMov, vRec: valor, vPag: valor });
    };

    const handleSave = async () => {
        if (processando) {
            return;
        }

        setProcessando(true);

        try {
            if (!caixaMov.vRec) {
                showAlert("Informe o valor de abertura!", 'danger');
                return;
            }

            const valorMov = parseCurrency(caixaMov.vRec);
            const caixaMovSalvar = { ...caixaMov, vRec: valorMov, vPag: valorMov };

            // if (caixaMov.vRec <= 0) {
            //     showAlert("O valor de abertura deve ser maior que zero!", 'danger');
            //     return;
            // }

            switch (parseInt(tipoMovCaixaSel)) {
                case TipoMovCaixa.Abertura:
                    caixaMovSalvar.tipoMovCaixa = TipoMovCaixa.Abertura;
                    await abrirCaixa(caixaMovSalvar);
                    caixa.aberto = true;
                    showAlert("Caixa aberto com sucesso!", 'success');    
                    break;
                case TipoMovCaixa.Suprimento:
                    caixaMovSalvar.tipoMovCaixa = TipoMovCaixa.Suprimento;
                    await lancManual(caixaMovSalvar);
                    caixa.aberto = true;
                    showAlert("Movimentação de caixa registrada com sucesso!", 'success');   
                    break;
                case TipoMovCaixa.Sangria:
                    caixaMovSalvar.tipoMovCaixa = TipoMovCaixa.Sangria;
                    await lancManual(caixaMovSalvar);
                    caixa.aberto = true;
                    showAlert("Movimentação de caixa registrada com sucesso!", 'success');  
                    break;
                default:
                    caixaMovSalvar.tipoMovCaixa = TipoMovCaixa.Abertura;
                    break;
            }

            setCaixa(caixa);                    
            onHide();
        } catch (error) {
            console.error("Erro ao abrir caixa: ", error);
            showMessage('Erro ao fechar caixa! '+  error, 'danger');

        } finally {
            setProcessando(false);
        }
    };

    if (!show) return null;

    return (
        
        <ModalPortal show={show}>
        <div className="modal d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document" style={{ maxWidth: '540px' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Movimentação de Caixa</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
                    </div>

                    <div className="modal-body">
  
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '12px 16px' }}>
                            <Input 
                                label="Usuário"
                                value={caixaMov?.usuario?.id + " - " + caixaMov?.usuario?.nome}                               
                                size="100%"
                                disabled={true}
                            />    
                                                                    
                        <Input
                            label="Caixa"
                            value={caixaMov?.caixa?.id + " - " + caixaMov?.caixa?.descricao}      
                            size="100%"
                            disabled={true}
                        /> 
                            <Input
                                label="Data/Hora"
                                value={formatDate(caixaMov?.dataHoraMov) + " - " + formatTime(caixaMov?.dataHoraMov)}
                                size="100%"
                                disabled={true}
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 140px', gap: '16px', marginTop: '12px', alignItems: 'start' }}>
                            <Select
                                label="Tipo de Movimentação"
                                value={parseInt(tipoMovCaixaSel)}
                                onChange={(e) => setTipoMovCaixaSel(e.target.value)}
                                options={[
                                    ...(!caixa.aberto ? [{ value: 1, label: 'Abertura' }] : []),
                                    { value: 2, label: 'Suprimento' },
                                    { value: 4, label: 'Sangria' }
                                ]}
                                disabled={!caixa.aberto}
                                autoFocus={caixa.aberto}
                                //msgErro={error}
                                size="100%"
                            />
                            <Input
                                label={"Valor "+ getDescricaoTipoMov(tipoMovCaixaSel)}
                                value={caixaMov.vRec}
                                onChange={(e) => handleValorMovChange(e.target.value)}
                                onBlur={(e) => handleValorMovBlur(e.target.value)}
                                size="100%"
                                style={{ textAlign: 'right', fontSize: '1.2em', fontWeight: 'bold', color: 'green',
                                    border: '1px solid green', borderRadius: '5px', padding: '5px', backgroundColor: 'lightgreen' }}
                                autoFocus={!caixa.aberto}
                            />
                        </div>
                        <div style={{ marginTop: '12px' }}>
                            <Input
                                label="Observação"
                                value={caixaMov.observacao || ''}
                                onChange={(e) => setCaixaMov({ ...caixaMov, observacao: e.target.value })}
                                rows={3}
                                maxLength={1000}
                                size="100%"
                                placeholder="Informe uma observação para a movimentação (opcional)"
                            />
                        </div>
                    </div>
                    <div className="modal-footer" style={{ gap: '10px' }}>
                        <button type="button" className="btn btn-secondary" onClick={onHide}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleSave} disabled={processando}>
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </ModalPortal>
        
    );
};

export default CaixaMovLan;
